import React, {
    useState,
    useRef,
    useContext,
    forwardRef,
    useImperativeHandle,
    useEffect,
} from 'react';
import ReactPlayer from 'react-player';
import {Popover, Button, notification, Input, Form, Image, Card} from 'antd';
import {MinusCircleOutlined, PlusOutlined} from '@/icons';
import {attaches} from './attachType';
import LinkFormModal from '@/page/component/LinkFormModal';
import {formLayout} from '@/page/customer/MomentPage/SendMoment/Form/formLayout';
import WelcomUploadModal from '@/page/component/WelcomUploadModal';
import MsgContext from '@/page/customer/RoomWelcomPage/msgContext';
import styles from './index.module.less';
import {useAuthStore} from '@/context/auth';
import _ from 'lodash';
import {
    addCustomerWelcomeConfig,
    addRoomWelcomeConfig,
    updateCustomerWelcomeConfig,
} from '@/api/customer';
import MediaType from '@/page/app/MediaPage/MediaType';
import msgTypes from '@/page/component/msg/MsgTypes';

const {TextArea} = Input;
const ConfigPage = forwardRef(({reload, isEdit}, ref) => {
    const [type, setType] = useState({
        key: 'image',
        label: '图片',
        maxCount: 1,
        maxSize: 2048000, // 2m
        accept: '.png, .jpg, .jpeg',
    });
    const [authStore] = useAuthStore();
    const extId = _.get(authStore, 'user.extId');
    const {
        setViewText,
        setViewLinks,
        setViewImages,
        setViewFiles,
        setViewVideos,
        viewLinks,
        viewImages,
        viewText,
        viewFiles,
        viewVideos,
        viewWebApps,
        setViewWebApps,
    } = useContext(MsgContext);
    const welcomUploadRef = useRef();
    const linkFormRef = useRef();
    const [visible, setVisible] = useState(false);
    const [key, setKey] = useState(0);
    const [mediaType, setMediaType] = useState(null);
    const [title, setTitle] = useState('');
    const [images, setImages] = useState([]);
    const [links, setLinks] = useState([]);
    const [text, setText] = useState('');
    const [files, setFiles] = useState([]);
    const [videos, setVideos] = useState([]);
    const [webApps, setWebApps] = useState([]);
    const [welcomeData, setWelcomeData] = useState({
        attachments: [],
    });

    useEffect(() => {
        if (isEdit) {
            setLinks(viewLinks);
            setImages(viewImages);
            setText(viewText);
            setWebApps(viewWebApps);
            setFiles(viewFiles);
            setVideos(viewVideos);
        }
    }, []);

    useImperativeHandle(ref, () => ({
        saveOrUpdate,
    }));

    function renderPopoverContent() {
        return (
            <div className={styles.attachContent}>
                {attaches.map(item => (
                    <div
                        className={styles.attachBlock}
                        key={item.key}
                        onClick={() => {
                            selectType(item.msgType);
                        }}
                    >
                        {item.value}
                    </div>
                ))}
            </div>
        );
    }

    function selectType(msgType) {
        if (videos.length + images.length + links.length + files.length + webApps.length > 0) {
            notification.warn({
                message: '最多添加一个个附件',
            });
            return;
        } else {
            setMediaType(msgType);
            let tempType = {};
            if (msgType === 'LINK' || msgType === 'WEBAPP') {
                console.log(11111111111);
                linkFormRef.current.open(msgType, true);
            } else {
                console.log(111122);
                tempType = MediaType[msgType];
                tempType.maxCount = 1;
                tempType.maxSize = msgType === 'VIDEO' ? 5242880 : 2097152; // 2MB
                setType(tempType);
                welcomUploadRef.current.showModal();
            }
        }
        // if (mediaType !== null) {
        //     notification.warn({
        //         message: '最多添加一个个附件',
        //     });
        //     return;
        // } else {
        //     let tempType = {};
        //     if (msgType !== 'LINK' || msgType !== 'WEBAPP') {
        //         tempType = MediaType[msgType];
        //         tempType.maxCount = 1;
        //         tempType.maxSize = 2097152; // 2MB
        //     }
        //     setType(tempType);
        //     setMediaType(msgType);
        //     welcomUploadRef.current.showModal();
        // }

        // setKey(selectKey);
        // if (links.length + images.length >= 3) {
        //     notification.warn({
        //         message: '最多添加一个个附件',
        //     });
        //     return;
        // }
        // if (selectKey === 0) linkFormRef.current.open();
        // if (selectKey === 1) {
        //     setTitle('图片上传');
        //     welcomUploadRef.current.showModal();
        // }
    }

    function remove(item, type = 0, index = null) {
        let temp = [];
        if (type === 0) {
            temp = images.filter(file => file.id !== item.id);
            setImages(temp);
            setViewImages(temp);
        } else if (type === 1) {
            temp = videos.filter(file => file.id !== item.id);
            setVideos(temp);
            setViewVideos(temp);
        } else if (type === 2) {
            temp = files.filter(file => file.id !== item.id);
            setFiles(temp);
            setViewFiles(temp);
        } else if (type === 4) {
            temp = [];
            setWebApps(temp);
            setViewWebApps(temp);
        } else {
            temp = links.filter((file, i) => i !== index);
            setLinks(temp);
            setViewLinks(temp);
        }
    }

    function renderActiveItem(type = 0) {
        if (type === 0) {
            return images.map((item, i) => (
                <div className={styles.file} key={i}>
                    <Image
                        src={item.urls.file}
                        width={200}
                        height={100}
                        style={{objectFit: 'cover'}}
                    />
                    <MinusCircleOutlined onClick={() => remove(item)} className={styles.icon} />
                </div>
            ));
        } else if (type === 1) {
            // 视频
            return videos.map((item, i) => (
                <div className={styles.file} key={i}>
                    <ReactPlayer
                        controls
                        playing={false}
                        url={item.urls.file}
                        width={200}
                        height={100}
                    />
                    <MinusCircleOutlined onClick={() => remove(item, 1)} className={styles.icon} />
                </div>
            ));
        } else if (type === 2) {
            // 文件
            return files.map((item, i) => (
                <div className={styles.file} key={i}>
                    {item.fileName}&nbsp;&nbsp;
                    <MinusCircleOutlined onClick={() => remove(item, 2)} className={styles.icon} />
                </div>
            ));
        } else if (type === 4) {
            return webApps.map((item, i) => (
                <div className={styles.file} key={i}>
                    <Card
                        hoverable
                        style={{width: 200}}
                        cover={
                            <img
                                alt="example"
                                style={{width: 200, height: 100, objectFit: 'cover'}}
                                src={item.pic_url}
                            />
                        }
                    >
                        <Card.Meta title={item.title} />
                    </Card>
                    <MinusCircleOutlined onClick={() => remove(item, 4)} className={styles.icon} />
                </div>
            ));
        } else {
            return links.map((item, i) => (
                <div key={i} className={styles.file}>
                    {item.title}&nbsp;&nbsp;
                    <a href={item.url} target="_blank">
                        ({item.url})
                    </a>
                    &nbsp;&nbsp;
                    <MinusCircleOutlined
                        onClick={() => remove(item, 3, i)}
                        className={styles.icon}
                    />
                </div>
            ));
        }
    }

    function afterUpload(data) {
        if (mediaType == 'LINK') {
            const {picurl, desc, url, title} = data;
            let media = new Array({
                title,
                desc,
                url,
                picurl,
            });
            setViewLinks(media);
            setLinks(media);
        } else if (mediaType == 'WEBAPP') {
            const {pic_media_id, appid, imageUrl, page, title} = data;
            let media = new Array({
                title,
                pic_media_id,
                appid,
                page,
                pic_url: imageUrl,
            });
            setWebApps(media);
            setViewWebApps(media);
        } else {
            let media = new Array(data);
            if (mediaType === 'IMAGE') {
                setImages(media);
                setViewImages(media);
            }
            if (mediaType === 'FILE') {
                setFiles(media);
                setViewFiles(media);
            }
            if (mediaType === 'VIDEO') {
                setVideos(media);
                setViewVideos(media);
            }
        }
        // let temp = {...welcomeData};
        // let temp = {...welcomeData};
        // if (key === 1) {
        //     if (links.length + images.length >= 3) {
        //         notification.warn({
        //             message: '最多添加一个附件,请删除最后上传的图片',
        //         });
        //         return;
        //     } else {
        //         let tempImages = [...images];
        //         tempImages.push(data);
        //         setViewImages(tempImages);
        //         setImages(tempImages);
        //     }
        // } else {
        //     const {picurl, desc, url, title} = data;
        //     const link = {
        //         title,
        //         desc,
        //         url,
        //         picurl,
        //     };
        //     let linkArr = [...links];
        //     linkArr.push(link);
        //     setViewLinks(linkArr);
        //     setLinks(linkArr);
        // }
        // setWelcomeData(temp);
    }

    function changeText(e) {
        setViewText(e.target.value);
        setText(e.target.value);
    }

    function saveOrUpdate(configId) {
        let temp = {...welcomeData};
        temp.attachments = [];
        if (links.length > 0) {
            links.forEach(item => {
                temp.attachments.push({
                    msgtype: 'link',
                    link: item,
                });
            });
        }
        if (images.length > 0) {
            images.forEach(item => {
                temp.attachments.push({
                    msgtype: 'image',
                    image: {attachId: item.id, pic_url: item.urls.file},
                });
            });
        }
        if (files.length > 0) {
            files.forEach(item => {
                temp.attachments.push({
                    msgtype: 'file',
                    file: {attachId: item.id, fileName: item.fileName},
                });
            });
        }
        if (videos.length > 0) {
            videos.forEach(item => {
                temp.attachments.push({
                    msgtype: 'video',
                    video: {attachId: item.id, pic_url: item.urls.file},
                });
            });
        }
        if (webApps.length > 0) {
            webApps.forEach(item => {
                temp.attachments.push({
                    msgtype: 'webApp',
                    miniprogram: item,
                });
            });
        }
        temp.text = {content: text};
        // temp.extId = extId;
        setWelcomeData(temp);
        console.log('temp', temp);
        if (configId) {
            console.log(temp);
            updateCustomerWelcomeConfig({configId: configId, searchParams: temp}).then(res => {
                if (res.status == 200) {
                    reload();
                    notification.success({
                        message: '更新成功',
                    });
                }
            });
        } else {
            console.log(JSON.stringify(temp));
            console.log(temp);
            addRoomWelcomeConfig({
                searchParams: temp,
                extIds: [],
            }).then(res => {
                console.log(res);
                if (res.status == 200) {
                    reload();
                    notification.success({
                        message: '创建成功',
                    });
                }
            });
        }

        // if (configId) {
        //     updateCustomerWelcomeConfig({configId: configId, searchParams: temp}).then(res => {
        //         reload();
        //         notification.success({
        //             message: '更新成功',
        //         });
        //     });
        // } else {
        //     // if (selectedUsers.users.length > 0) {
        //     //     const selectExtIds = selectedUsers.users.map(item => item.id);
        //     //     addCustomerWelcomeConfig({
        //     //         searchParams: temp,
        //     //         extIds: selectExtIds,
        //     //     }).then(res => {
        //     //         reload();
        //     //         notification.success({
        //     //             message: '创建成功',
        //     //         });
        //     //     });
        //     // }
        // }
    }

    return (
        <div>
            <Form layout="vertical" style={{margin: '20px'}} {...formLayout}>
                <Form.Item label="消息内容：">
                    <TextArea rows={10} maxLength={2000} onChange={changeText} value={text} />
                </Form.Item>
                {links.length > 0 && (
                    <Form.Item label="链接：">{<>{renderActiveItem(3)}</>}</Form.Item>
                )}
                {images.length > 0 && (
                    <Form.Item label="图片：">
                        {<div className={styles.renderBlock}>{renderActiveItem()}</div>}
                    </Form.Item>
                )}
                {videos.length > 0 && (
                    <Form.Item label="视频：">
                        {<div className={styles.renderBlock}>{renderActiveItem(1)}</div>}
                    </Form.Item>
                )}
                {files.length > 0 && (
                    <Form.Item label="文件：">{<>{renderActiveItem(2)}</>}</Form.Item>
                )}
                {webApps.length > 0 && (
                    <Form.Item label="小程序：">
                        {<div className={styles.renderBlock}>{renderActiveItem(4)}</div>}
                    </Form.Item>
                )}
                <Form.Item {...formLayout}>
                    <Popover
                        content={renderPopoverContent()}
                        title="选择附件类型「最多添加1个附件」"
                        trigger="click"
                        visible={visible}
                        onVisibleChange={visible => setVisible(visible)}
                        placement="bottomLeft"
                    >
                        <Button type="dashed" icon={<PlusOutlined />}>
                            添加附件
                        </Button>
                    </Popover>
                </Form.Item>
            </Form>
            <LinkFormModal ref={linkFormRef} createLink={afterUpload} url={'/welcome'} />
            <WelcomUploadModal
                ref={welcomUploadRef}
                category="welcome"
                modalTitle={title}
                type={type}
                afterUpload={afterUpload}
                // afterCloseModal={afterCloseModal}
            />
        </div>
    );
});

ConfigPage.displayName = 'ConfigPage';

export default ConfigPage;
